export default __webpack_public_path__ + "static/media/foto-daniel.a0542d69.jpg";